import { type ReactNode, useRef, useState } from 'react'

import { cn } from '@/utils'
import {
  TooltipContent,
  TooltipPortal,
  TooltipRoot,
  TooltipTrigger,
} from './Tooltip'

interface TruncatedTextProps {
  text: string
  children?: ReactNode
  className?: string
}

export const TruncatedText = ({
  text,
  children,
  className,
}: TruncatedTextProps) => {
  const textRef = useRef<HTMLDivElement>(null)
  const [open, setOpen] = useState(false)

  const handleOpenChange = (shouldOpen: boolean) => {
    const element = textRef.current
    const isTruncated = element
      ? element.scrollWidth > element.clientWidth
      : false

    setOpen(shouldOpen && isTruncated)
  }

  return (
    <TooltipRoot open={open} onOpenChange={handleOpenChange}>
      <TooltipTrigger asChild>
        <div ref={textRef} className={cn('truncate', className)}>
          {children ?? text}
        </div>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent>{text}</TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  )
}
